import { memo, type PropsWithChildren } from "react";
import { Navigate, useLocation } from "infrastructure/router";
import { WebRoutes } from "consts/enpoints/web";
import { RoleName } from "consts/auth";
import useAuth from "features/auth/useAuth";
import useUser from "features/auth/useUser";
import type { RedirectIfAuthenticatedProps } from "./types";

const RedirectIfAuthenticated = ({
    children,
    redirectTo = new Map()
        .set(WebRoutes.Transactions, [
            RoleName.Employee
        ])
}: PropsWithChildren<RedirectIfAuthenticatedProps>) => {
    const location = useLocation();
    const { hasRole } = useUser();
    const { isAuthenticated, isPending } = useAuth();

    const getRedirectPath = () => {
        for (const [path, roles] of Array.from(redirectTo.entries())) {
            if (hasRole(roles)) {
                return path;
            }
        }

        return WebRoutes.Root;
    };

    if (isPending()) {
        return null;
    }

    const from = (location.state as any)?.from?.pathname || getRedirectPath();

    if (isAuthenticated()) {
        return <Navigate to={from} state={{ from: undefined }} replace />;
    }

    return (
        <>
            {children}
        </>
    );
};

export default memo(RedirectIfAuthenticated);
